import Cookies from "js-cookie";

const isValidUser = () => {
  const token = Cookies.get("jwtToken"); 
  return !!token
};


export { isValidUser };

export const getUamIdOfLoggedInUser = () => {
  const token = Cookies.get("jwtToken");

  if (!token) {
    return false;
  }
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const uamId = payload.uam_id;
    return uamId;
  }
  catch (error) {
    return false;
  }
}

export const getAuthToken = () => {
  return Cookies.get("jwtToken") || "";
};
